// extracted by mini-css-extract-plugin
export default {"content":"eoa-z","title":"foa-z","subTitle":"goa-z","banner":"hoa-z","productCardOverride":"ioa-z"};